import { IJobHistory, IJobHistorySearchRequest } from '@th-common/interfaces/job-history';
import { IPagedResult } from '@th-common/interfaces/paged-result';
import { apiRoot } from '@th-common/store/api';

export const api = apiRoot.enhanceEndpoints({}).injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getJobExecutions: builder.query<IPagedResult<IJobHistory>, {
      jobId: number;
      searchRequest: IJobHistorySearchRequest;
    }>({
      query: ({
        jobId,
        searchRequest,
      }) => {
        return {
          url: `job/${jobId}/job-executions/all`,
          method: 'POST',
          body: searchRequest,
        };
      },
    }),
  }),
});
